import { Heading, Text } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const SectionWrapper = styled.div`
    flex: 1 1 0;
    background-color: ${({ theme }) => theme.uiBricks?.primaryBackground || '#ffffff'};
    padding: 16px;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (max-width: ${BreakPoints.TABLET}) {
        min-width: 0;
        gap: 16px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        flex: 1 1 100%;
        gap: 16px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Title = styled(Heading)`
    margin: 0;
    color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
`;

export const MetaRow = styled(Text)`
    color: #333436;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
`;

export const ContentRow = styled.div`
    display: flex;
    gap: 10px;
    align-items: stretch;
`;

const SPECS_COLUMNS = 2;
const SPECS_COLUMN_GAP = 8;
const SPECS_COLUMN_GAP_TABLET = 12;

/* width of one item, minus the share of the column gap it has to give up */
const specItemBasis = (gap: number) => `calc(${100 / SPECS_COLUMNS}% - ${(gap * (SPECS_COLUMNS - 1)) / SPECS_COLUMNS}px)`;

export const SpecsGrid = styled.div`
    flex: 1 1 55%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    row-gap: 8px;
    column-gap: ${SPECS_COLUMN_GAP}px;

    @media (max-width: ${BreakPoints.PHONE}) {
        row-gap: 5px;
        column-gap: 2px;
    }
`;

export const SpecItem = styled.div`
    /* fixed basis, not a growing one, so a short final row keeps the column alignment */
    flex: 0 0 ${specItemBasis(SPECS_COLUMN_GAP)};
    /* without this a long value ("Moonlight Cloud") pushes the item past its basis */
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media (max-width: ${BreakPoints.TABLET}) {
        flex-basis: ${specItemBasis(SPECS_COLUMN_GAP_TABLET)};
    }
`;

export const Label = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.dashboardDrActivityDashboardRemoveCoBuyerCloseMsgSvgFill || '#727479'};

    @media (max-width: ${BreakPoints.TABLET}) {
        line-height: 16px;
    }
`;

export const Value = styled(Text)`
    color: #333436;
`;

export const PriceCard = styled.div`
    flex: 0 0 42%;
    background: #f4f4f4;
    padding: 16px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;

    @media (max-width: ${BreakPoints.TABLET}) {
        flex: 0 0 38%;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        flex: 0 0 45%;
        padding: 16px 12px;
        gap: 14px;
    }
`;

export const PriceBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    text-align: center;
`;

export const PriceCardLabel = styled(Text)`
    color: #434447;
`;

export const StrikedPrice = styled(Text)<{ isStrike?: boolean }>`
    text-decoration: ${({ isStrike }) => (isStrike ? 'line-through' : 'none')};
    color: #636569;
`;

export const DiscountLabel = styled(Text)<{ isSavings?: boolean }>`
    color: ${({ isSavings, theme }) =>
        isSavings ? '#128601' : theme.uiBricks?.dashboardDrActivityDashboardRemoveCoBuyerCloseMsgSvgFill || '#727479'};
`;

export const DiscountValue = styled(Text)<{ isSavings?: boolean }>`
    color: ${({ isSavings, theme }) => (isSavings ? '#128601' : theme.uiBricks?.creditAppErrorMessageTextColor || '#c20000')};
`;

export const PriceDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.uiBricks?.paymentTermsCashDisclaimerBackgroundColor || '#e4e5e6'};
`;

export const FinalPriceLabel = styled(Text)`
    color: #434447;
`;

export const FinalPrice = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
`;
